import apiWrapper from './helpers'

export default class MessageCategoryFolder extends apiWrapper('/message_category_folders') {}
